module.exports = __webpack_public_path__ + "static/media/cookie.985ac31f.svg";